module.exports = __webpack_public_path__ + "img/eg4.d9c6d91f.png";